var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellerNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 388,
    viewBox: "0 0 480 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 192.727,
    r: 174.545,
    fill: "#235543"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7273,
    cy: 61.8182,
    r: 17.4545,
    fill: "#235543"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 293.091,
    r: 13.0909,
    fill: "#235543"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5454,
    cy: 319.273,
    r: 21.8182,
    fill: "#235543"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.182,
    cy: 118.545,
    r: 21.8182,
    fill: "#235543"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.727,
    cy: 42.1818,
    r: 15.2727,
    fill: "#235543"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_10_628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 120.625L255.081 114.308L240.002 120.732V300.579L378.959 242.349V62.4218L379.636 62.1381L378.959 61.8379V61.5356L378.611 61.6837L241.097 0.727295L100.364 60.676L101.03 60.962L100.364 240.159L240 300.472L240 120.625Z",
    fill: "#76F99B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 120.625V300.472L100.364 240.159L101.03 60.9619L240 120.625Z",
    fill: "url(#paint0_linear_10_628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.003 120.732V300.579L378.96 242.349V61.5356L240.003 120.732Z",
    fill: "url(#paint1_linear_10_628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 120.625L379.636 62.1381L241.097 0.727295L100.364 60.676L240 120.625Z",
    fill: "#5ACE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.001 38.2541L292.105 98.8008L293.369 142.923L332.288 126.864L331.112 82.4631L187.892 23.3914L153.001 38.2541Z",
    fill: "#76F99B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_10_628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.909,
    y: 227.636,
    width: 122.182,
    height: 122.182,
    rx: 61.0909,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.909 311.636L254 302.727M260.364 287.455C260.364 299.404 250.677 309.091 238.727 309.091C226.778 309.091 217.091 299.404 217.091 287.455C217.091 275.505 226.778 265.818 238.727 265.818C250.677 265.818 260.364 275.505 260.364 287.455Z",
    stroke: "#76F99B",
    strokeWidth: 4.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_10_628",
    x: 56.7273,
    y: 0.727292,
    width: 366.545,
    height: 387.124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10_628"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.4545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_628"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8.72727,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_10_628"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43.6364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.1818
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10_628",
    result: "effect2_dropShadow_10_628"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10_628",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_10_628",
    x: 161.455,
    y: 210.182,
    width: 157.091,
    height: 157.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.72727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10_628"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10_628",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_628",
    x1: 100.364,
    y1: 241.063,
    x2: 155.51,
    y2: 91.7119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ACE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ACE66",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_628",
    x1: 240.001,
    y1: 124.252,
    x2: 397.453,
    y2: 155.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ACE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ACE66",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerNotFound);
export default __webpack_public_path__ + "static/media/sellerNotFound.72479975c8d55abbe1bb4a47f1084d09.svg";
export { ForwardRef as ReactComponent };